import { createSlice } from "@reduxjs/toolkit";

export const ProductSearchPage = createSlice({
  name: "Product Search",
  initialState: {
    productSearchPage: {
      categoryId: "All",
      subCategoryId: "All",
      packageCategoryId: "All",
      searchValue: "",
      searchValueForPackage: "",
      reviewType:"All",
      orderId: "",
      clientName: "",
      reviewSearchVal: "",
    },
  },
  reducers: {
    setProductSearchPage: (state, action) => {
      state.productSearchPage = action.payload;
    },
  },
});

export const { setProductSearchPage } = ProductSearchPage.actions;

export default ProductSearchPage.reducer;
